import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { VendPageRoutingModule } from './vend-routing.module';

import { VendPage } from './vend.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    VendPageRoutingModule
  ],
  declarations: [VendPage]
})
export class VendPageModule {}
